// Based on angular-chart.js Copyright (c) Jerome Touffe-Blin. 
// Greatly simplified and stripped down. 
// Modified to handle {x,y} data points for time series charts.
angular.module('iqxCore')
  .directive('iqxChart', function () {
    return {
      restrict: 'CA',
      scope: {
        chartType: '=?',
        chartData: '=?',
        chartOptions: '=?',
        chartColours: '=?'
      },
      link: function (scope, elem) {
        var chart    // Holds the created Chart object

        scope.$watch('chartData', createChart, true)
        scope.$watch('chartOptions', createChart, true)
        scope.$watch('chartColours', createChart, true)
        scope.$watch('chartType', createChart, true)

        scope.$on('$destroy', destroyChart)

        function createChart() {
          destroyChart()  // Destroy any existing chart first
          if (!scope.chartData) return
          var type = scope.chartType || 'line'
          var colours = getColours(scope)
          var cvs = elem[0]  // The canvas
          var ctx = cvs.getContext('2d')
          var data = angular.extend({}, scope.chartData)
          mergeDataWithColours(data, colours)
          var options = angular.extend({}, scope.chartOptions)
          chart = new Chart(ctx, {
            type: type,
            data: data,
            options: options
          });
          cvs.onclick = function (evt) { scope.$emit('chart-click', chart, evt) }
          scope.$emit('chart-create', chart)
        }

        function destroyChart() {
          if (!chart) return
          chart.destroy()
          scope.$emit('chart-destroy', chart)
          chart = undefined
        }

      }
    }

    function getColours(scope) {   // Returns an array of multi-shade colour objects long enough for the number of datasets
      scope.defColours = {  // Default colours. Doubles as lookup map for named colours.
        blue: '#468499',
        green: '#6dc066',
        red: '#FF0000',
        yellow: '#FFD700',
        purple: '#800080',
        lime: '#00FF00',
        fuchsia: '#FF00FF',
        aqua: '#00FFFF',
        olive: '#808000',
        orange: '#FFA500',
        teal: '#008080',
        navy: '#000080',
        maroon: '#800000',
        gray: '#808080'
      }
      var cols = scope.chartColours || Object.keys(scope.defColours)
      var maxDataLength = 0  // The length of the longest dataset
      for (var i = 0; i < scope.chartData.datasets.length; i++) {
        maxDataLength = Math.max(maxDataLength, scope.chartData.datasets[i].data.length)
      }
      while (cols.length < maxDataLength) {
        cols.push(getRandomColour())
      }
      return cols.map(convertColour, scope)
    }

    function convertColour(colour) {  // Converts various colour types to a multi-shade object
      if (typeof colour === 'object' && colour !== null) return colour  // Already an object
      if (typeof colour === 'string' && colour[0] !== '#') colour = this.defColours[colour.toLowerCase()]  // A named colour - look up the hex
      if (typeof colour === 'string' && colour[0] === '#') return getColour(hexToRgb(colour.substr(1)))  // A hex colour
      return getRandomColour()  // Not understood
    }

    function getRandomColour() {
      var colour = [getRandomInt(0, 255), getRandomInt(0, 255), getRandomInt(0, 255)]
      return getColour(colour)
    }

    function getColour(colour) {  // Create the multi-shade object
      return {
        backgroundColor: rgba(colour, 0.2),
        borderColor: rgba(colour, 1),
        pointBackgroundColor: rgba(colour, 1),
        pointBorderColor: '#fff',  // white
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: rgba(colour, 0.8)
      }
    }

    function getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min
    }

    function rgba(colour, alpha) {
      return 'rgba(' + colour.concat(alpha).join(',') + ')'
    }

    // Credit: http://stackoverflow.com/a/11508164/1190235
    function hexToRgb(hex) {
      var bigint = parseInt(hex, 16),
        r = (bigint >> 16) & 255,
        g = (bigint >> 8) & 255,
        b = bigint & 255
      return [r, g, b]
    }

    function mergeDataWithColours(data, colours) {
      data.datasets = data.datasets.map(function (item, i) {
        return angular.merge({}, colours[i], data.datasets[i])
      })
    }

  })
